import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AiResponse } from '../../ai-chat/types/ai-response.type';

export type AiConfig = {
  enabled: boolean;
};

@Injectable()
export class AiService {

  private readonly path = '/ai';

  constructor(
    private readonly baseService: BaseService,
    private readonly translateService: TranslateService,
  ) {}

  interact(content: string, chatId?: string): Observable<AiResponse> {
    const locale = this.translateService.instant('locale');
    return this.baseService.post(this.path, '/interact', { content, chatId, locale })
  }

  getConfig(): Observable<AiConfig> {
    return this.baseService.get(this.path, '/config');
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/ai.service.ts